enum DpkType {

    OpenPosition = "openPosition",
    openposition = "openposition",
    OpenDeposit = "opendeposit",
    Deposit = "deposit",
    OpenUploadDocument = "openuploaddocument",
    UserFeedback = "feedback",
    StartChat = "startchat",
    RegisterActivity = "registeractivity"
}

namespace DpkType {

    export function deserialize(v: string): DpkType {
        if (v) {
            if (v.indexOf("dpk:openPosition") === 0) {
                return DpkType.OpenPosition;
            } else if (v.indexOf("dpk:openposition") === 0) {
                return DpkType.openposition;
            } else if (v.indexOf("dpk:opendeposit") === 0) {
                return DpkType.OpenDeposit;
            } else if (v.indexOf("dpk:deposit") === 0) {
                return DpkType.Deposit;
            } else if (v.indexOf("dpk:openuploaddocument") === 0) {
                return DpkType.OpenUploadDocument;
            } else if (v.indexOf("dpk:feedback") === 0) {
                return DpkType.UserFeedback;
            } else if (v.indexOf("dpk:startchat") === 0) {
                return DpkType.StartChat;
            } else if (v.indexOf("dpk:registeractivity") === 0) {
                return DpkType.RegisterActivity;
            }
        }
        return null;
    }
}

export {DpkType};
